<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @beforeEnter="beforeEnter"
    @afterEnter="afterEnter"
    @beforeLeave="beforeLeave"
    @afterLeave="afterLeave">
    <div :class="classes" v-if="show">
      <div class="modal-background" @click="deactive"></div>
      <div class="modal-container fct-box-mobile">
        <div class="modal-content">
            <slot></slot>
        </div>
      </div>
      <button class="modal-close" @click="deactive" v-if="closable"></button>
    </div>
  </transition>
</template>

<script>
import BaseModal from './BaseModal'

export default {
  mixins: [BaseModal],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes () {
      return ['modal', 'animated', 'is-active']
    }
  }
}
</script>
<style lang="scss">
  @import "../../../node_modules/bulma/sass/utilities/mixins";

  .modal-content, .model-card {
    max-height: 100vh !important;
    @include mobile() {
      padding: 60px;
      margin: 0;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
</style>
